import { observable } from 'mobx';

import { UserProfileDetailsDTO } from '../../dtos/userProfileDetail.dtos';

class UserProfileModel {
  userId: string;
  phoneNumber: string;
  countryCode: string;
  @observable email: string;
  profilePicUrl: string;
  name: string;
  dob: string;
  gender: string;
  isPhoneNumberVerified: boolean;
  isEmailVerified: boolean;
  coverPageUrl: string;
  age: number;
  stateOfResidence: string;
  occupation: string;
  lastName: string;
  currentCity: string;
  currentState: string;
  pincode: string;
  currentCountry: string;
  currentDistrict: string;
  whatsappMobileNumber: string;
  whatsappMobileNumberCountryCode: string;
  iWantToReceiveUpdatesDirectlyOnWhatsapp?: boolean;
  canUpdatePhoneNumber?: boolean;
  phoneNumberUpdateDueDateTime: string;
  preferredLanguages: string[];
  taskFlowInviteCode: string | undefined;
  affiliateCode: string | undefined;
  nationality: string;
  familyIncome: string;

  constructor(profileData: UserProfileDetailsDTO) {
    const {
      userID,
      phoneNumber,
      countryCode,
      email,
      profilePicUrl,
      name,
      dob,
      isEmailVerified,
      isPhoneNumberVerified,
      coverPageUrl,
      stateOfResidence,
      occupation,
      lastName,
      currentCity,
      currentState,
      currentCountry,
      currentDistrict,
      pinCode,
      inviteCode,
      whatsappMobileNumber,
      whatsappMobileNumberCountryCode,
      iWantToReceiveUpdatesDirectlyOnWhatsapp,
      canUpdatePhoneNumber,
      phoneNumberUpdateDueDateTime,
      preferredLanguages,
      gender,
      age,
      nationality,
      familyIncome
    } = profileData;
    this.userId = userID;
    this.phoneNumber = phoneNumber;
    this.countryCode = countryCode;
    this.email = email;
    this.profilePicUrl = profilePicUrl;
    this.name = name;
    this.dob = dob;
    this.gender = gender;
    this.isPhoneNumberVerified = isPhoneNumberVerified;
    this.isEmailVerified = isEmailVerified;
    this.coverPageUrl = coverPageUrl;
    this.age = age;
    this.stateOfResidence = stateOfResidence;
    this.occupation = occupation;
    this.lastName = lastName;
    this.currentCity = currentCity;
    this.currentState = currentState || '';
    this.currentCountry = currentCountry;
    this.currentDistrict = currentDistrict;
    this.taskFlowInviteCode =
      inviteCode && inviteCode.length === 4 ? inviteCode : undefined;
    this.affiliateCode =
      inviteCode && inviteCode.length === 6 ? inviteCode : undefined;
    this.pincode = pinCode;
    this.whatsappMobileNumber = whatsappMobileNumber;
    this.whatsappMobileNumberCountryCode = whatsappMobileNumberCountryCode;
    this.iWantToReceiveUpdatesDirectlyOnWhatsapp =
      iWantToReceiveUpdatesDirectlyOnWhatsapp;
    this.canUpdatePhoneNumber = canUpdatePhoneNumber;
    this.phoneNumberUpdateDueDateTime = phoneNumberUpdateDueDateTime;
    this.preferredLanguages = preferredLanguages;
    this.nationality = nationality;
    this.familyIncome = familyIncome;
  }
}

export default UserProfileModel;
